import React from 'react'
import { Box, Divider } from '@mui/material'

import CreateCustomMappingButton from 'Pages/User/CustomMapping/CreateButton'
import UploadXlsButton from 'Pages/User/CustomMapping/XlsUploadButton'
import UploadXlsTemplate from 'Pages/User/CustomMapping/UploadXlsTemplate'


// Upload, example and create of the open mapping list, kept together in the table's toolbar after
// search / download / filter (the tour points at the group)
export default function CustomMappingActions({ path, sx = {} }) {
	return <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, verticalAlign: 'middle', ...sx }}>
		<Divider orientation="vertical" flexItem sx={{ my: 1, ml: 1, mr: 0.5 }}/>
		<UploadXlsButton path={path}/>
		<UploadXlsTemplate path={path}/>
		<CreateCustomMappingButton path={path}/>
	</Box>
}
